import { useEffect, useState } from "react";
import {
  Box,
  Page,
  PageRoute,
  TabContext,
  buildOptionalParams,
  buildPath,
  buildTemplatePath,
  useParams,
} from "@compass/core";
import { TextingQueueDetailDto } from "generated/openApi";
import ApiService from "services/apiService";
import { TextingQueueDetailPageHeader } from "./TextingQueueDetailPageHeader";
import { TextingQueueDetailPageTabs } from "./TextingQueueDetailPageTabs";
import { TextingQueueInfo } from "./TextingQueueInfo";
import { TextingQueueItems } from "./TextingQueueItems";

const routeName = "textingQueueDetail";

class Params {
  id: number = 0;
}

class OptionalParams {
  tab?: TextingQueueDetailTab = undefined;
}

export const textingQueueDetailPageRoute: PageRoute<Params, OptionalParams> = {
  handle: "Texting Queue Details",
  templatePath: buildTemplatePath(routeName, Params),
  getPath: (params) => buildPath(routeName, params),
  getOptionalParams: (params) => buildOptionalParams(params),
};

export type TextingQueueDetailTab = "Info" | "Queue Items";

export const TextingQueueDetailPage = () => {
  const { params, optionalParams } = useParams(routeName, Params, OptionalParams);
  const [currentTab, setCurrentTab] = useState<TextingQueueDetailTab>(optionalParams.tab || "Info");
  const [textingQueue, setTextingQueue] = useState<TextingQueueDetailDto>({
    id: params.id,
    sent: 0,
    total: 0,
    items: [],
  });

  useEffect(() => {
    ApiService.textingQueue.get(params.id).then(setTextingQueue);
  }, []);

  return (
    <TabContext value={currentTab}>
      <Page
        isForm
        header={<TextingQueueDetailPageHeader textingQueue={textingQueue} />}
        tabs={
          <TextingQueueDetailPageTabs
            itemTotal={textingQueue.items?.length || 0}
            setCurrentTab={setCurrentTab}
          />
        }
      >
        <Box hidden={currentTab !== "Info"}>
          <TextingQueueInfo textingQueue={textingQueue} />
        </Box>
        <Box hidden={currentTab !== "Queue Items"}>
          <TextingQueueItems textingQueue={textingQueue} />
        </Box>
      </Page>
    </TabContext>
  );
};
